import { Check, Plane } from "lucide-react";
import { PACKAGES } from "@/data";
import Reveal from "@/components/Reveal";

export default function Services({ onSelect }) {
  return (
    <section id="packages" className="relative bg-ink py-28 md:py-40 border-t border-white/10" data-testid="packages-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <Reveal>
            <span className="overline">[ Travel-class packages ]</span>
            <h2 className="mt-6 font-display font-semibold tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              Choose your <span className="text-purple">cabin class</span>.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-white/55 max-w-sm font-body">
              Four tiers of care, inspired by the way you fly. From an essential clean to
              full white-glove concierge detailing.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 xl:grid-cols-4 border-l border-t border-white/10">
          {PACKAGES.map((p, i) => (
            <Reveal key={p.key} delay={i * 0.07}>
              <div
                data-testid={`package-card-${i}`}
                className="group relative h-full border-r border-b border-white/10 bg-surface/40 hover:bg-surface transition-colors duration-500 p-8 flex flex-col"
              >
                {p.popular && (
                  <span className="absolute top-6 right-6 font-mono text-[0.6rem] uppercase tracking-[0.2em] text-ink bg-purple px-2 py-1">
                    Popular
                  </span>
                )}
                <div className="flex items-center gap-3 mb-8">
                  <span className={`font-mono text-sm ${p.accent === "purple" ? "text-purple" : "text-lime"}`}>
                    [{p.index}]
                  </span>
                  <Plane
                    size={16}
                    className={`${p.accent === "purple" ? "text-purple" : "text-lime"} opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-500`}
                  />
                </div>

                <h3 className="font-display text-2xl font-medium tracking-tight leading-tight">{p.key}</h3>
                <p className="mt-1 text-white/45 text-sm font-body">{p.tagline}</p>
                <p className="mt-6 font-mono text-lg text-white">{p.price}</p>

                <ul className="mt-8 space-y-3 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-start gap-3 text-sm text-white/65 font-body">
                      <Check size={15} className={`mt-0.5 shrink-0 ${p.accent === "purple" ? "text-purple" : "text-lime"}`} />
                      {f}
                    </li>
                  ))}
                </ul>

                <button
                  data-testid={`package-select-${i}`}
                  onClick={() => onSelect(p.key)}
                  className={`mt-10 w-full py-3.5 font-mono text-xs uppercase tracking-[0.18em] border ${
                    p.accent === "purple"
                      ? "btn-fill-purple border-purple text-purple"
                      : "btn-fill border-lime text-lime"
                  }`}
                >
                  Select {p.key}
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
